import { render, staticRenderFns } from "./TrxCollectionRecord.vue?vue&type=template&id=334ceb88&scoped=true"
import script from "./TrxCollectionRecord.vue?vue&type=script&lang=js"
export * from "./TrxCollectionRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334ceb88",
  null
  
)

export default component.exports